
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import API, { auth, apikey } from '../../constants/api';
import {
    DEVICE_FETCH,
    MACHINE_TYPE_FETCH,
    CREATE_NEW_MACHINE,
    UPDATE_DEVICE_PROFILE,
    DEVICE_DETAIL_FETCH,
    DEVICE_ONOFFLINE_FETCH
} from '../actions';

import {
    deviceSuccess,
    deviceFail,
    machineTypeSuccess,
    machineTypeFail,
    createMachineSuccess,
    createMachineFail,
    deviceDetailFetchSuccess,
    deviceDetailFetchFail,
    deviceOnlinOfflineSuccess,
    deviceOnlinOfflineFail
} from './actions';

// console.log("auth : ",auth)

const deviceFetchAsync = async (data) =>
    await API.get('/device/device',
    {
      headers : {
        'Content-Type': 'application/json',
        'userid': data.user_id,
        'usertoken': data.user_token,
        'apikey': apikey
      }
    })
        .then(data => data)
        .catch(error => error);

//* Get Device List
function* deviceFetch({ payload }) {
  const { device, history } = payload;
  // console.log("history : ",history)
    try {
        const deviceFetch = yield call(deviceFetchAsync, device);
        if (deviceFetch.data.StatusCode === "0000") {
            yield put(deviceSuccess(deviceFetch.data.ResultValues));
        } else if(deviceFetch.data.StatusCode === "0005") {
            localStorage.removeItem('user_id');
            history.push('/user')
        } else {
            yield put(deviceFail(deviceFetch.data.Message));
        }
    } catch (error) {
        yield put(deviceFail(error));
    }
}

const machineTypeFetchAsync = async () =>
    await API.get('/machine/machinetype',
    {
      headers : {
        'Content-Type': 'application/json',
        'apikey': apikey
      }
    })
        .then(data => data)
        .catch(error => error);

//* Get Machine Type
function* machineTypeFetch({ payload }) {
    try {
        const machineTypeFetch = yield call(machineTypeFetchAsync);
        if (machineTypeFetch.data.StatusCode === "0000") {
            yield put(machineTypeSuccess(machineTypeFetch.data.ResultValues));
        } else {
            yield put(machineTypeFail(machineTypeFetch.data.Message));
        }
    } catch (error) {
        yield put(machineTypeFail(error));
    }
}

//* Create New Machine
const createMachineAsync = async (req) =>
    await API.post('/machine/'+req.actionType, {
      merchantId:req.merchantId,
      machineId:req.machineId,
      deviceId:req.deviceId,
      machineName:req.machineName,
      machineType:req.machineType,
      machineTag:req.machineTag,
      machineStatus:req.machineStatus,
      createBy:req.createBy,
      updateBy:req.updateBy,
      machineSku:req.machineSku,
      updateprofileType:req.updateprofileType
    },
    {
      headers : {
        'Content-Type': 'application/json',
        'apikey': apikey
      }
    })
        .then(data => data)
        .catch(error => error);

  function* createMachine({ payload }) {
    const { machineCreate } = payload;
    // console.log("saga machineCreate : ",machineCreate)
      try {
          const createMachine = yield call(createMachineAsync, machineCreate);
          // console.log("saga createMachine : ",createMachine)
          if (createMachine.data.StatusCode === "0000") {
              yield put(createMachineSuccess(createMachine.data));
          } else {
              yield put(createMachineFail(createMachine.data.Message));
          }
      } catch (error) {
          yield put(createMachineFail(error));
      }
  }

  //* Update Profile To Mqtt
  const updateDeviceProfileAsync = async (req) =>
      await API.post('/device/mqtt/updateprofile', {
        machineId:req.machineId
      },
      {
        "headers" : auth
      })
          .then(data => data)
          .catch(error => error);

  function* updateDeviceProfile({ payload }) {
    const { profile } = payload;
      try {
          const updateDeviceProfile = yield call(updateDeviceProfileAsync, profile);
          if (updateDeviceProfile.data.StatusCode === "0000") {
              yield put(createMachineSuccess(updateDeviceProfile.data));
          } else {
              yield put(createMachineFail(updateDeviceProfile.data.Message));
          }
      } catch (error) {
          yield put(createMachineFail(error));
      }
  }

  const deviceDetailFetchAsync = async (id) =>
      await API.get('/device/device/'+id,
      {
        headers : {
          'Content-Type': 'application/json',
          'apikey': apikey
        }
      })
          .then(data => data)
          .catch(error => error);

    //* Get Device Detail
    function* deviceDetailFetch({ payload }) {
      const { deviceDetail } = payload;
        try {
            const deviceDetailFetch = yield call(deviceDetailFetchAsync,deviceDetail);
            // console.log("deviceDetailFetch ", deviceDetailFetch)
            if (deviceDetailFetch.data.StatusCode === "0000") {
                yield put(deviceDetailFetchSuccess(deviceDetailFetch.data.ResultValues));
            } else {
                yield put(deviceDetailFetchFail(deviceDetailFetch.data.Message));
            }
        } catch (error) {
            yield put(deviceDetailFetchFail(error));
        }
    }

    const deviceOnlineOfflineFetchFetchAsync = async (user, queryString) =>
        await API.get('/device/monitor/checkstatus',
        {
          headers : {
            'Content-Type': 'application/json',
            'userid': user.user_id,
            'usertoken': user.user_token,
            'apikey': apikey
          }
        })
            .then(devices => devices)
            .catch(error => error);

    function* deviceOnlineOfflineFetch({ payload }) {
      const { userid, usertoken, startdate, enddate } = payload.deviceOnlineOffline
      let userData = {}
      let query = {}
      userData.user_id = userid
      userData.user_token = usertoken
      query.startdate = startdate
      query.enddate = enddate

        try {
            const deviceOnlineOfflineFetch = yield call(deviceOnlineOfflineFetchFetchAsync, userData, query);
            if (deviceOnlineOfflineFetch.data.StatusCode === "0000") {
              let device = deviceOnlineOfflineFetch.data.ResultValues[0];
              const data = {}
              data.label = Object.keys(device)
              data.value = Object.values(device)

              yield put(deviceOnlinOfflineSuccess(data));

            } else {
                yield put(deviceOnlinOfflineFail(deviceOnlineOfflineFetch.data.Message));
            }
        } catch (error) {
            yield put(deviceOnlinOfflineFail(error));
        }
    }


export function* watchDeviceFetch() {
    yield takeEvery(DEVICE_FETCH, deviceFetch)
    yield takeEvery(MACHINE_TYPE_FETCH, machineTypeFetch)
    yield takeEvery(CREATE_NEW_MACHINE, createMachine)
    yield takeEvery(UPDATE_DEVICE_PROFILE, updateDeviceProfile)
    yield takeEvery(DEVICE_DETAIL_FETCH, deviceDetailFetch)
    yield takeEvery(DEVICE_ONOFFLINE_FETCH, deviceOnlineOfflineFetch)
}

export default function* rootSaga() {
    yield all([
        fork(watchDeviceFetch),
    ]);
}
